import { BTText } from "@btnet/core-components";

import { BdsIconBills, BdsIconSparkle, BdsIconUploadSimple } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";

import "./BillDraftsEmptyState.less";

interface IBillDraftsEmptyStateProps {
    onUpload: () => void;
}

export const BillDraftsEmptyState: React.FC<IBillDraftsEmptyStateProps> = ({ onUpload }) => {
    return (
        <BTRow
            justify="center"
            align="middle"
            className="BillDraftsEmptyState"
            data-testid="billDraftsEmptyState"
        >
            <BTCol className="BillDraftsEmptyState-content">
                <div className="BillDraftsEmptyState-iconContainer">
                    <div className="BillDraftsEmptyState-iconBox">
                        <BdsIconBills size="3xl" />
                    </div>
                    <div className="BillDraftsEmptyState-sparkleBadge">
                        <BdsIconSparkle size="sm" />
                    </div>
                </div>
                <BTText text="No bills waiting — you're all caught up" size="distinct-lg" />
                <BTText
                    text="Drop bills & receipts here, or send them to your inbox email. AI Bill Capture will extract the details and create drafts automatically."
                    size="normal-md"
                    className="BillDraftsEmptyState-description"
                />
                <div className="BillDraftsEmptyState-actions">
                    <BTButton
                        data-testid="billDraftsEmptyStateUpload"
                        icon={<BdsIconUploadSimple />}
                        onClick={onUpload}
                    >
                        Upload bills
                    </BTButton>
                    <BTText
                        text="or drop files anywhere"
                        size="normal-sm"
                        className="BillDraftsEmptyState-orText"
                    />
                </div>
            </BTCol>
        </BTRow>
    );
};
